:host {
  display: table-cell;
  font-size: var(--sc-font-size-medium);
  padding: var(--sc-table-cell-spacing, var(--sc-spacing-small)) var(--sc-table-cell-spacing, var(--sc-spacing-large)) !important;
  vertical-align: middle;
}

:host([slot="head"]) {
  background: var(--sc-table-cell-background-color, var(--sc-color-gray-50));
  font-size: var(--sc-font-size-x-small);
  padding: var(--sc-table-cell-spacing, var(--sc-spacing-small));
  text-transform: uppercase;
  font-weight: var(--sc-font-weight-semibold);
  letter-spacing: var(--sc-letter-spacing-loose);
  color: var(--sc-color-gray-500);
}

:host(:last-child) {
  text-align: right;
}

sc-table-cell {
  display: table-cell;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
